import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Tooltip } from '@shared/Tooltip';
import { FONT_FAMILY_MAIN, LINKS_COLOR, TEXT_COLOR } from '../../theme';
import Info from '../../images/info.inline.svg';

const Container = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

const Label = styled.span`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  letter-spacing: -0.2px;
  color: ${TEXT_COLOR};
`;

const StyledInfoIcon = styled(Info)`
  fill: ${LINKS_COLOR};
  width: 24px;
  height: 24px;
  margin-left: 6px;
  cursor: pointer;
  vertical-align: middle;
`;

const InfoLabel = ({
  label, infoText, tooltipPosition, zIndex, tooltipWidth, activeZIndex,
}) => (
  <Container>
    <Label>{label}</Label>
    <Tooltip
      content={infoText}
      position={tooltipPosition}
      trigger="hover"
      zIndex={zIndex}
      width={tooltipWidth}
      activeZIndex={activeZIndex}
    >
      <StyledInfoIcon />
    </Tooltip>
  </Container>
);

InfoLabel.propTypes = {
  label: PropTypes.string.isRequired,
  infoText: PropTypes.node.isRequired,
  tooltipPosition: PropTypes.string,
  zIndex: PropTypes.number.isRequired,
  tooltipWidth: PropTypes.number,
  activeZIndex: PropTypes.number,
};

InfoLabel.defaultProps = {
  tooltipPosition: 'right center',
  tooltipWidth: 250,
  activeZIndex: 0,
};

export { InfoLabel };
